import { Component, ElementRef, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { TruncatePipe } from 'src/app/shared/pipes/truncate/truncate.pipe';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';
import { PopupRef, PopupService } from '@progress/kendo-angular-popup';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

const HIDE_POPUP_DELAY_TIME = 100; //ms
@Component({
  selector: 'bizz-grid-cell-link',
  templateUrl: './grid-cell-link.component.html',
  styleUrls: ['./grid-cell-link.component.scss'],
  standalone: true,
  imports: [
    TruncatePipe,
    IconComponent
  ]
})
export class GridCellLinkComponent extends GridCellBaseComponent<string> implements OnInit{
  @ViewChild('anchor', { read: ElementRef })
  public anchorEl: ElementRef;
  @ViewChild('readmorePopupTemplateRef', { static: true })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public readmorePopupTemplateRef: TemplateRef<any>;
  private readmorePopup: PopupRef | null = null;

  private popupService = inject(PopupService);

  public showReadMoreIcon: boolean = false;
  private anchorHovered = false;
  private popupHovered = false;

  public ngOnInit(): void {
    this.onDataChanged();
  }

  public override onDataChanged(): void {
    if(this.data['ShowReadMoreIconFor' + this.column.field]){
      this.showReadMoreIcon = this.data['ShowReadMoreIconFor' + this.column.field] as unknown as boolean;
    }
    else if(this.column.ShowReadMoreIcon)
      this.showReadMoreIcon = true;

    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

  public onAnchorMouseEnter(): void {
    this.anchorHovered = true;
    this.showPopup();
  }

  public onAnchorMouseLeave(): void {
    this.anchorHovered = false;
    setTimeout(() => {
      if (!this.anchorHovered && !this.popupHovered) this.hidePopup();
    }, HIDE_POPUP_DELAY_TIME);
  }

  public onPopupMouseEnter(): void {
    this.popupHovered = true;
    this.showPopup();
  }

  public onPopupMouseLeave(): void {
    this.popupHovered = false;
    setTimeout(() => {
      if (!this.anchorHovered && !this.popupHovered) this.hidePopup();
    }, HIDE_POPUP_DELAY_TIME);
  }

  public showPopup(): void {
    if (this.readmorePopup != null) return;

    this.readmorePopup = this.popupService.open({
      anchor: this.anchorEl,
      content: this.readmorePopupTemplateRef,
      popupClass:
        'w-svw h-svh sm:w-fit sm:h-auto sm:min-w-[400px] sm:-mt-[0.5rem] sm:rounded-md maxw-sm:!top-0 !z-[9999] maxw-sm:!left-0 maxw-sm:!right-0',
      animate: false,
      anchorAlign: { horizontal: 'center', vertical: 'bottom' },
      popupAlign: { horizontal: 'center', vertical: 'top' },
      collision: { horizontal: 'fit', vertical: 'fit' }
    });
  }

  public hidePopup(): void {
    if (this.readmorePopup) {
      this.readmorePopup.close();
      this.readmorePopup = null;
    }
    event?.stopPropagation();
    event?.preventDefault();
  }
}
